import React from "react";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

export const StatusTag = ({ text = "app.status", color = "primary", variant = "caption" }) => (
  <>
    {" - "}
    <Typography component={"span"} variant={variant} color={color}>
      <FormattedMessage id={text} />
    </Typography>
  </>
);

const UserTagStatus = ({ apt, premium, isBlocked, variant }) => {
  return (
    <>
      {!apt && <StatusTag text="app.inapt" color="error" variant={variant} />}
      {premium && <StatusTag text="app.premium" color="primary" variant={variant} />}
      {isBlocked && <StatusTag text="app.user.isBlocked" color="error" variant={variant} />}
    </>
  );
};

export default UserTagStatus;
